import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsBricksUnderMinimun extends AnnualPeriodsError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks is less than the minimum to buy', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default AnnualPeriodsBricksUnderMinimun;
